export default __webpack_public_path__ + "static/media/Head_6_Ear_1_C5.d2f8ecc4.svg";